import get from "lodash/get"
import axios from "axios"
import {
  GET_GUEST_ORDER_HISTORY_DETAILS_PENDING,
  GET_GUEST_ORDER_HISTORY_DETAILS_FULFILLED,
  GET_GUEST_ORDER_HISTORY_DETAILS_FAILED,
} from "constants-lib/actionTypes"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"

export const pendingAC = () => ({
  type: GET_GUEST_ORDER_HISTORY_DETAILS_PENDING,
})

export const failedAC = () => ({
  type: GET_GUEST_ORDER_HISTORY_DETAILS_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_GUEST_ORDER_HISTORY_DETAILS_FULFILLED,
  payload: data,
})

export const getOrderDetailsForGuest = (searchId) => (dispatch, getState) => {
  dispatch(pendingAC())
  const api = `ORDER_HISTORY_DETAILS`
  const template = URITemplate(urls.url[api])

  const state = getState()
  const lang = state?.siteLanguage?.language

  const url = template.expand({
    searchId,
    lang,
  })

  return axios
    .create()
    .get(url)
    .then((response) => {
      dispatch(fulfilledAC(get(response, "data.data", {})))
      return get(response, "data.data", {})
    })
    .catch((error) => {
      dispatch(failedAC())
      throw error
    })
}
